"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStaticContentState = void 0;
var StaticContentState_1 = require("@/pages/staticContent/states/StaticContentState");
exports.defaultStaticContentState = {
    title: 'Terms And Conditions',
    content: [
        {
            type: StaticContentState_1.StaticContentTypes.MODAL,
            // tslint:disable-next-line:max-line-length
            text: 'Thank you for using the services provided by Okay Property Agency Limited (OKAY.com). By accessing and using OKAY.com\'s website (Website), you agree to be legally bound by OKAY.com\'s terms and conditions (Terms) as outlined below.',
        },
        {
            type: StaticContentState_1.StaticContentTypes.HEADER,
            text: 'GENERAL ACCEPTANCE OF USE',
        },
        {
            type: StaticContentState_1.StaticContentTypes.PARAGRAPH,
            // tslint:disable-next-line:max-line-length
            text: 'Terms may be subject to revision and visitors who access the Website will be deemed to have accepted these Terms & any modifications without restriction. Accordingly, visitors should check the date of Last Revision (which appears at the end of this document). If at any time you do not agree to these Terms, kindly avoid using the Website.',
        },
    ],
};
